import { render, staticRenderFns } from "./CharactersForcePowers.vue?vue&type=template&id=2fd6d296&lang=pug&"
import script from "./CharactersForcePowers.vue?vue&type=script&lang=ts&"
export * from "./CharactersForcePowers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports